// extracted by mini-css-extract-plugin
module.exports = {"fotoFunTitle":"idt-fotofuntitle_fotofuntitle__ntncw"};